export enum NotificationTemplates {
  Wishlist = 'wishlist',
  Compare = 'compare',
}
